import React from "react";
import Sidebar from "./Sidebar";

export default function DashboardLayout({ children, ...props }) {
    return (
        <section className="trainer-dashboard-section">
            <div className="container-fluid">
                <div className="row">
                    {/* Sidebar */}
                    <Sidebar {...props} />

                    {/* Main Content */}
                    <div className="col-lg-10 col-md-9 dashboard-main-content">
                        <div className="dashboard-content">
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

